export const ClickToEditDirective = ['ClickToEditFactory', function(ClickToEditFactory) {
   return ClickToEditFactory.get('input', true);
}];
